<template>
  <block ref="breceipt" :nobody="true">
    <date-range title="Phiếu Xuất" v-model="daterange" class="mx-1"></date-range>
    <div style="padding: 5px;" class="d-flex">
      <input type="text" v-model="listQuery.search" class="form-control" />
      <button @click="fetchData()" class="btn btn-primary ml-2" style="width: 100px;">Tìm</button>
    </div>
    <hr class="my-1" />
    <soft-table
      @rowSelected="tbSetRowSelected"
      @rowClicked="tbRowClicked"
      class="table align-items-center table-flush"
      tbody-classes="list"
      :pending="false"
      :dataTable="tableData"
      :fields="fields"
      :showAll="true"
      :minHeight="$hControl"
      @contextMenuItemClick="tbHandleContextMenuItemClick"
      ref="soft-table"
    >
      <template v-slot:cell(code)="row">
        <b-button @click="row.toggleDetails" style="user-select: text;" variant="link">
          {{ row.value }}
        </b-button>
      </template>
      <template v-slot:row-details="row">
        <div class="py-2" style="background:#fff">
          <b-row align-h="center" class="mx-0 mb-2">
            <b-button
              v-if="!row.item.userVerify"
              @click="verifyReceipt(row.item)"
              variant="success"
              class="mt-2"
              size="sm"
            >
              <i class="fa fa-check" aria-hidden="true"></i>
              Đã xuất hàng
            </b-button>
            <b-button @click="printReceipt(row.item)" variant="primary" class="mt-2" size="sm">
              <i class="fa fa-print" aria-hidden="true"></i>
              In lại phiếu
            </b-button>
          </b-row>
          <base-table :data="row.item.ReceiptBillDetails">
            <template slot="columns">
              <th>STT</th>
              <th>Mã Đơn hàng</th>
              <th>Mã sản phẩm</th>
              <th>Tên sản phẩm</th>
              <th>Quy cách</th>
              <th>Màu sắc</th>
              <th>Số lượng</th>
            </template>

            <template slot-scope="{ row, index }">
              <tr :key="index">
                <td class="bg-info text-light col-fix ">
                  {{ index + 1 }}
                </td>
                <td>{{ row.order.code }}</td>
                <td class="text-center">{{ row.productInfo.product.code }}</td>
                <td class="text-center">
                  {{ row.productInfo.product.name }}
                  <!-- <span v-if="row.productCustom != ''"><br />{{ row.productCustom }}</span> -->
                  <span v-if="row.reason"><br />{{ row.reason.name }}</span>
                </td>
                <td class="text-center">{{ row.productInfo.productSpecify.name }} mm</td>
                <td class="text-center">{{ row.productInfo.color.label }}</td>
                <td class="text-center">
                  {{ $formatNumber(row.quantity) }}
                </td>
              </tr>
            </template>
          </base-table>
        </div>
      </template>
      <template v-slot:cell(customer)="{ value }">
        <strong>{{ value.code }}</strong> <br />
        <span>{{ value.name }}</span>
      </template>
      <template v-slot:cell(userCreate)="{ value }">
        <span v-if="value.id" class="badge badge-primary">{{ value.username }}</span>
      </template>
      <template v-slot:cell(userVerify)="{ value }">
        <span v-if="value.id" class="badge badge-success">{{ value.username }}</span>
        <span v-else class="badge badge-danger">
          Chưa được duyệt
        </span>
      </template>
      <template v-slot:cell(userManage)="{ value }">
        <span v-if="value.id" class="badge badge-info">{{ value.username }}</span>
        <span v-else class="badge badge-danger">
          Chưa có người hỗ trợ
        </span>
      </template>
      <template>
        <pagination
          class="mt-2 mb-2 mr-2"
          slot="footer"
          :total="listQuery.total"
          :perPage="listQuery.limit"
          @change="pagChange"
        />
      </template>
    </soft-table>
    <preview ref="preview"></preview>
  </block>
</template>
<script>
import { receiptService } from '@/_services';
import Preview from './__PreviewOut';

export default {
  name: 'receipt-out',
  components: {
    Preview
  },
  props: {},
  data() {
    return {
      countChecked: 0,
      listQuery: {
        search: '',
        page: 1,
        limit: 30,
        total: 0,
        from: 0,
        to: 0
      },
      daterange: {},
      lastIndexCustomerSelected: 0,
      info: {},
      tableData: [],
      fields: [
        {
          variant: 'primary',
          key: 'id',
          class: 'checkbox'
        },
        {
          key: 'code',
          label: 'Mã phiếu',
          sortable: true
        },
        {
          tdClass: 'text-left',
          key: 'customer',
          label: 'Người Đặt hàng',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'userCreate',
          label: 'Người tạo',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'userVerify',
          label: 'Người duyệt hồ sơ',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'dateCreated',
          sortable: true,
          label: 'Ngày tạo'
        },
        {
          tdClass: 'text-center',
          key: 'dateUpdated',
          sortable: true,
          label: 'Lần cuối sửa đổi'
        }
      ]
    };
  },
  mounted() {},
  methods: {
    fetchData() {
      this.pending = true;
      this.listQuery.from = this.daterange.from;
      this.listQuery.to = this.daterange.to;
      this.$refs.breceipt.block();
      receiptService
        .findAllOut(this.listQuery)
        .then(res => {
          this.$refs.breceipt.unBlock();
          this.tableData = res.data.data;
          this.listQuery.total = res.data.total;
          this.$refs['soft-table'].selectRow(this.lastIndexCustomerSelected);
        })
        .finally(() => {
          this.pending = false;
        });
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      console.log('context menu', a);
    },
    handleUpdate() {},
    handleCreate() {},
    handleCopy() {},
    handleHelp() {
      alert('help');
    },
    handleDelete() {
      if (this.countChecked == 0) return;
    },
    tbSetRowSelected(items) {
      this.customerSelecteds = items;
      this.countChecked = items.length;
    },
    printReceipt(item) {
      this.$refs.preview.visible = true;
      let productReceipts = [];
      item.ReceiptBillDetails.forEach(element => {
        productReceipts.push({
          id: element.id,
          note: element.note,
          quantity: element.quantity,
          total: element.total,
          color: element.productInfo.color,
          product: element.productInfo.product,
          productCustom: element.productCustom,
          reason: element.reason,
          reasonId: element.reasonId,
          productSpecify: element.productInfo.productSpecify,
          position: element.productInfo.position,
          order: element.order,
          unit: element.unit,
          length: element.length,
          colorText: element.colorText,
          colorCode1: element.colorCode1,
          colorCode2: element.colorCode2,
          colorCode: element.colorCode
        });
      });
      this.$refs.preview.setData(item, productReceipts);
    },
    verifyReceipt(item) {
      this.$refs.breceipt.block();
      receiptService
        .verifyOut(item.id)
        .then(res => {
          item.status = true;
          item.userVerify = res.data.userVerify;
          this.$alertify.success(res.message, {
            duration: 4000
          });
        })
        .finally(() => {
          this.$refs.breceipt.unBlock();
        });
    }
  },
  watch: {
    daterange: function() {
      this.fetchData();
    }
  }
};
</script>
<style lang="scss"></style>
